<template lang="pug">
  #MySa
    .p-3.text-center.mb-5
      h5.font-weight-bold.mb-3 您與顧問綁定成功囉！
      .mb-5
        ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
          :profileUrl="saInfo.sa.picture_url",
          :style="{ 'width': '200px', 'height': '200px' }"
        )
      p.mb-2 {{ saInfo.sa.chinese_last_name }}{{ saInfo.sa.chinese_first_name }}
      p.mb-0
        i.fas.fa-map-marker-alt.mr-2
        span 門市：{{ saInfo.store.title }}
    .row.p-3.pt-5.mx-2
      .col-12
        button.btn.btn-block.btn-primary(
          type="button",
          @click="backToLINEHandler()"
        ) 開始與顧問一對一

</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'BindSaSuccess',
  components: {
    ProfilePhotoSticker
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    if (!vm.saInfo) {
      vm.$swal.fire({
        icon: 'error',
        title: '非法嘗試[Err1]',
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false
      });
    }
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  },
  computed: {
    ...mapState({
      saInfo: (state) => state.member_bind_sa.saInfo
    })
  }
};
</script>

<style>

</style>
